export const REPORT_ASSETS = Object.freeze({
  cover: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/报告封面.jpg',
  catalog: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/目录页.jpg',
  innerPage: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/报告内页.jpg',
  chapterTitle: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/目录背景.png',
  moduleTitle: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/模块标题背景.png',
  riskGaugeDial: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/最高风险指数仪表盘.png',
  riskGaugePointer: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/最高风险指数指针.png',
  solarTermDial: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/1_0002_新对话-(7).png',
  solarTermPointer: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/节气指针.png',
});

export default REPORT_ASSETS;
